import { TabItem } from "smart-webcomponents-react/tabs";
import { getParamsObject } from "../../../Tools/Tools";
import AccountsTableForTabs from "./detailComponents/AccountsTableForTabs";
import AddressForTabs from "./detailComponents/AddressForTabs";
import ClsBookTableForTabs from "./detailComponents/ClsBookTableForTabs";
import DocumentsForTabs from "./detailComponents/DocumentsForTabs";
import ParamsForTabs from "./detailComponents/ParamsForTabs";
import LoadingMask from "../../../NotWorkArea(Side&Head)/LoadingMask";
import TreeMultiCheckForTabs from "./detailComponents/TreeMultiCheckForTabs";
import PaytypesForTabs from "./detailComponents/PaytypesForTabs";
import PaytypesLinksForTabs from "./detailComponents/PaytypesLinksForTabs";
import PaytypesSearchForTabs from "./detailComponents/PaytypesSearchForTabs";
import { ViewClass } from "../../../Tools/Consts";
import { SmetaTabItem } from "../../../Tools/Tabs/PinIcons";
import GradesGrid from "./departmentsComponents/LocalGroupGrid";
import ParamsSearchForTabs from "./detailComponents/ParamsSearchForTabs";
import DescriptionForTas from "./detailComponents/DescriptionForTabs";

export function getDetailContent(selector, props, data) {
  const properties = { ...props, ...data };
  const returnComponent = {
    accounts: <AccountsTableForTabs props={properties} />,
    documents: <DocumentsForTabs props={properties} />,
    params: <ParamsForTabs props={properties} />,
    addressParams: <AddressForTabs props={properties} />,
    clsbook: <ClsBookTableForTabs props={properties} />,
    treeMultiCheck: <TreeMultiCheckForTabs props={properties} />,
    paytypesSearch: <PaytypesSearchForTabs props={properties} />,
    links: <PaytypesLinksForTabs props={properties} />,
    paytypes: <PaytypesForTabs props={properties} />,
  };
  return returnComponent[selector];
}

const getSmetaTab = (content, props, index) => {
  return (
    <SmetaTabItem key={`${props.Caption}-${index}`} label={props.Caption}>
      {content}
    </SmetaTabItem>
  );
};

export const getSmetaTabContent = (props, index) => {
  const returnComponent = {
    [ViewClass.TableRep]: getSmetaTab(<AccountsTableForTabs props={props} />, props, index),
    [ViewClass.DocBook]: getSmetaTab(<DocumentsForTabs props={props} />, props, index),
    [ViewClass.ParamDlg]: getSmetaTab(<ParamsForTabs props={props} />, props, index),
    [ViewClass.Address]: getSmetaTab(<AddressForTabs props={props} />, props, index),
    [ViewClass.ClsBook]: getSmetaTab(<ClsBookTableForTabs props={props} />, props, index),
    [ViewClass.Grades]: getSmetaTab(<GradesGrid props={props} />, props, index),
    Search: getSmetaTab(<ParamsSearchForTabs props={props} />, props, index),
    Description: getSmetaTab(<DescriptionForTas props={props} />, props, index),
  };

  return returnComponent[props.CLSID] || getSmetaTab(<DocumentsForTabs props={props} />, props, index);
};

export function updateTabContentFunc(data) {
  switch (data.CLSID) {
    case "params":
      data?.onRequest(data)?.then((res) => {
        const parambox = data.element.querySelector("#paramsBox");
        if (parambox && parambox.update) {
          parambox.update(res);
        }
      });
      break;

    case "addressParams":
      data.onRequest(data).then((res) => {
        const parambox = data.element.querySelector("#paramsBox");
        parambox.update(getParamsObject(res, data.selectedRecordID, res.Caption, data.Module));
      });
      break;
    case "documents":
      const docDiv = data.element.querySelector(`#Documents${data.SectionID}`);
      if (docDiv && docDiv.refreshMainGrid) {
        docDiv.refreshMainGrid({
          DocCfgID: data.DocCfgID || data.ObjType,
          ParentID: data.selectedRecordID,
        });
      }
      break;
    case "accounts":
      const accBox = data.element.querySelector(`#accBox`);
      if (accBox && accBox.refreshMainGrid) {
        accBox.refreshMainGrid({
          ObjType: data.detailItem.ObjType ? data.detailItem.ObjType : data.detailItem.Params.ObjType,
          GroupID: data.selectedRecordID,
        });
      }
      break;

    case ViewClass.ClsBook:
      const clsbookBox = data.element.querySelector(`#clsBookBox`);
      if (clsbookBox && clsbookBox.refreshMainGrid) {
        clsbookBox.refreshMainGrid({
          ObjType: data.ObjType || data.Params.ObjType,
          GroupID: data.selectedRecordID,
        });
      }
      break;

    case "treeMultiCheck":
      const treeBox = data.element.querySelector(`#treeBox`);
      if (treeBox && treeBox.update) {
        treeBox.update(data.selectedRecordID);
      }
      break;
    case "paytypesSearch":
      break;
    case "links":
      const linksBox = data.element.querySelector(`#linksBox`);
      if (linksBox && linksBox.update) {
        linksBox.update(data.selectedRecordID);
      }
      break;
    case "paytypes":
      const paytypesBox = data.element.querySelector(`#paytypesBox`);
      if (paytypesBox && paytypesBox.update) {
        paytypesBox.update(data.selectedRecordID);
      }
      break;
  }
}

export function getLoadTab(Caption, index) {
  return (
    <TabItem
      id={`LoadTab_${Caption}-${index}`}
      key={`TabItem_${Caption}-${index}`}
      style={{
        textTransform: "none",
        width: "100%",
        height: "100%",
        padding: "0px",
        display: "inline-block",
      }}
      label={Caption}
    >
      <div id={`item_${Caption}`} load="true" style={{ width: "100%", height: "100%", position: "relative" }}>
        <LoadingMask />
      </div>
    </TabItem>
  );
}

export function getFullTab(detailItem, content, index) {
  return (
    <TabItem
      id={`Tab_${detailItem.Caption}-${index}`}
      key={`TabItem_${detailItem.Caption}-${index}`}
      style={{
        textTransform: "none",
        width: "100%",
        height: "100%",
        padding: "0px",
        display: "inline-block",
      }}
      label={detailItem.Caption}
    >
      <div id={`item_${detailItem.Caption}`} style={{ width: "100%", height: "100%", position: "relative" }}>
        {content}
      </div>
    </TabItem>
  );
}
